import { Alignment, Position } from '@nucleus/types/web';
import React from 'react';
import styled from 'styled-components';
import { BlockLayout, blockLayoutInnerProps } from '../../blockLayouts/Base';
import { BlockCalendarGrid } from '../../blocks/BlockCalendarGrid';
import { BlockCover } from '../../blocks/BlockCover';
import { blockInfoHasContent } from '../../blocks/BlockInfo';
import { Overline } from '../../components/Base';
import { SpacerTop } from '../../sectionLayouts/Spacers';
import { CalendarBlockLayoutProps, getPositionRow } from './CalendarLayout';

export const CalendarBlockLayoutCover = (props: CalendarBlockLayoutProps): JSX.Element => {
  const innerProps = blockLayoutInnerProps(props);

  const row = getPositionRow(props.blockInfoPosition);

  const renderInfo = blockInfoHasContent(props.blocks[0]);

  return (
    <StyledBlockLayout
      {...props}
      bodyAlignment={props.blocks[0]?.bodyAlignment ?? props.blockBodyAlignment}
      row={row}
      renderInfo={renderInfo}
    >
      <SpacerTop />
      <StyledBlockCover {...innerProps} block={props.blocks[0]} />
      <StyledSpacerBottom />
      <StyledBlockCalendarGrid {...innerProps} block={props.blocks[0]} />
    </StyledBlockLayout>
  );
};

const StyledSpacerBottom = styled(SpacerTop)``;
const StyledBlockCalendarGrid = styled(BlockCalendarGrid)``;
const StyledBlockCover = styled(BlockCover)``;

const StyledBlockLayout = styled(BlockLayout)<{ bodyAlignment?: Alignment; row: Position; renderInfo: boolean }>`
  ${StyledSpacerBottom} {
    display: ${(props) => (props.row === Position.Center ? 'block' : 'none')};
  }

  ${StyledBlockCover} {
    min-height: ${(props) => {
      switch (props.height) {
        case 'medium':
          return '40vh';
        case 'large':
          return '55vh';
        default:
          return undefined;
      }
    }};
  }

  ${Overline} {
    text-align: ${(props) => props.bodyAlignment ?? 'left'};
  }

  ${StyledBlockCalendarGrid} {
    padding: var(--unit-length);
    padding-top: ${(props) => (props.renderInfo ? '0' : undefined)};
  }
`;
